import ForgetPassword from "../Components/Pages/Others/Authentication/ForgetPassword";
import LoginSimple from "../Components/Pages/Others/Authentication/LoginSimple";
import LoginSweetAlert from "../Components/Pages/Others/Authentication/LoginSweetAlert";
import LoginWithTooltip from "../Components/Pages/Others/Authentication/LoginWithTooltip";
import LoginWithValidation from "../Components/Pages/Others/Authentication/LoginWithValidation";
import Maintenance from "../Components/Pages/Others/Authentication/Maintenance";
import RegisterSimple from "../Components/Pages/Others/Authentication/RegisterSimple";
import RegisterWithBgImage from "../Components/Pages/Others/Authentication/RegisterWithBgImage";
import RegisterWithImageTwo from "../Components/Pages/Others/Authentication/RegisterWithImageTwo";
import RegisterWizard from "../Components/Pages/Others/Authentication/RegisterWizard";
import ResetPassword from "../Components/Pages/Others/Authentication/ResetPassword";
import UnlockUser from "../Components/Pages/Others/Authentication/UnlockUser";
import VisualLogin from "../Components/Pages/Others/Authentication/VisualLogin";
import VisualLogin2 from "../Components/Pages/Others/Authentication/VisualLogin2";
import ComingWithBgImage from "../Components/Pages/Others/ComingSoon/ComingWithBgImage";
import ComingWithBgVideo from "../Components/Pages/Others/ComingSoon/ComingWithBgVideo";
import SimpleComingSoon from "../Components/Pages/Others/ComingSoon/SimpleComingSoon";
import ErrorPage1 from "../Components/Pages/Others/ErrorPage/ErrorPage1";
import ErrorPage2 from "../Components/Pages/Others/ErrorPage/ErrorPage2";
import ErrorPage3 from "../Components/Pages/Others/ErrorPage/ErrorPage3";
import ErrorPage4 from "../Components/Pages/Others/ErrorPage/ErrorPage4";
import ErrorPage5 from "../Components/Pages/Others/ErrorPage/ErrorPage5";
import ErrorPage6 from "../Components/Pages/Others/ErrorPage/ErrorPage6";

export const authRoutes = [
    //coming soon pages
    { path: `/comingsoon/coming_soon_simple`, element: <SimpleComingSoon /> },
    { path: `/comingsoon/coming_bg_video`, element: <ComingWithBgVideo /> },
    { path: `/comingsoon/coming_bg_img`, element: <ComingWithBgImage /> },
    //authentication
    { path: `/authentication/login_simple`, element: <LoginSimple /> },
    { path: `/authentication/login_bg_image`, element: <VisualLogin /> },
    { path: `/authentication/login_with_image_two`, element: <VisualLogin2 /> },
    { path: `/authentication/login_validation`, element: <LoginWithValidation /> },
    { path: `/authentication/login_tooltip`, element: <LoginWithTooltip /> },
    { path: `/authentication/login_sweetalert`, element: <LoginSweetAlert /> },
    { path: `/authentication/register_simple`, element: <RegisterSimple /> },
    { path: `/authentication/register_bg_image`, element: <RegisterWithBgImage /> },
    { path: `/authentication/register_with_image_two`, element: <RegisterWithImageTwo /> },
    { path: `/authentication/unlock_user`, element: <UnlockUser /> },
    { path: `/authentication/forget_password`, element: <ForgetPassword /> },
    { path: `/authentication/reset_password`, element: <ResetPassword /> },
    { path: `/authentication/maintenance`, element: <Maintenance /> },
    { path: `/authentication/register_wizard`, element: <RegisterWizard /> },
    // Error Pages
    { path: `/errors/error_400`, element: <ErrorPage1 /> },
    { path: `/errors/error_401`, element: <ErrorPage2 /> },
    { path: `/errors/error_403`, element: <ErrorPage3 /> },
    { path: `/errors/error_404`, element: <ErrorPage4 /> },
    { path: `/errors/error_500`, element: <ErrorPage5 /> },
    { path: `/errors/error_503`, element: <ErrorPage6 /> },
]